import { Link } from '@mui/material';
import styled from 'styled-components';

export const StyledIncLoginLink = styled(Link)`
  vertical-align: baseline;
`;
